import { render, staticRenderFns } from "./MaterialReplacement.vue?vue&type=template&id=317a65a1&"
import script from "./MaterialReplacement.vue?vue&type=script&lang=js&"
export * from "./MaterialReplacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports